// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.2-next',
  revision: 'f423e0db',
  branch: 'next',
  date: 'Fri, 24 Apr 2026 14:22:15 GMT'
};